import React from "react";
import { EditAdmin } from "../../pages";

const EditAdminContainer = ({closeModal, data}) => {
    return (
        <EditAdmin
        data={data}
        closeModal={closeModal}
        />
    )
}
export default EditAdminContainer;